import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/fillList_action";
import {
  role_list_action,
  role_delete_action,
} from "../../../actions/security_action/roles_action";
import { StatusActionId, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
class Role extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userId: "",
      roleID: "",
      Name: "",
      Description: "",
      StatusID: "",
      roleList: [],
      filteredData: [],
      statusFillList: [],
      isAccordionExpanded: false,      currentPage: 1,
    };
    this.navigateRoleAdd = this.navigateRoleAdd.bind(this);
    this.navigateRoleUpdate = this.navigateRoleUpdate.bind(this);
    this.getRoleList = this.getRoleList.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.clearFilters = this.clearFilters.bind(this);    this.updateItem = this.updateItem.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
          sessionStorage.getItem("roleId") == 4 ?
              this.props.navigate('/checkList') :
              <></>
      }
     }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.getRoleList();
    this.getFillList(StatusActionId, userId, "", "");
  }
  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == StatusActionId) {
            this.setState({ statusFillList: data.data, isLoading: false });
            console.log(data.data, "status");
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getRoleList() {
    const { userId, Name, StatusID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .role_list_action(Name, StatusID)
      .then((data) => {
        console.log(data);
        if (data.error !== 1) {
          this.setState({
            roleList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          toast.error(data.msg, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      console.log(this.state.roleList);
    }, 500);
  }
  handleDelete(roleID) {
    const confirmed = window.confirm(
      "Are you sure you want to delete this Role?"
    );

    if (confirmed) {
      this.props
        .role_delete_action(roleID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getRoleList(); // Refresh the holiday list after deletion
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  navigateRoleAdd() {
    this.props.navigate("/role_add");
  }
  navigateRoleUpdate(roleID) {
    console.log(roleID);
    this.props.navigate(`/role_add`, {
      state: { roleID: roleID },
    });
  }
  handleSearch() {
    const { Name, Status } = this.state;
    if (Array.isArray(this.props.events)) {
      let filteredData = this.props.events.filter(
        (item) =>
          item["Name"].toLowerCase().includes(Name.toLowerCase()) &&
          item["Status"].toLowerCase().includes(Status.toLowerCase())
      );

      this.setState({ roleList: filteredData });
    }
    this.getRoleList(Name, Status);
  }
  clearFilters() {
    const { Name, Status } = this.state;
    this.setState({
      Name: "",
      Status: "",
    });
    setTimeout(() => {
      this.handleSearch();
    }, 100);
  }
  updateItem(item) {
    this.setState({ currentPage: item });
  }
  roleRecords(roleList) {
    // const { userList } =this.state
    return (
      <table
      className="table table-bordered table-striped"
      id="dashboard-table"
    >
      <thead>
        <tr>
          <th style={{ width: "10%" }}>Role Name</th>
          <th style={{ width: "30%" }}>Role Description</th>
          <th style={{ width: "5%" }}>Status</th>
          <th className="text-right" style={{ width: "5%" }}>
            Action
          </th>
        </tr>
      </thead>
      <tbody id="myTable">
        {roleList.length > 0
          ? roleList.map((data) => (
              <tr>
                <td>{data.Name}</td>
                <td>{data.Description}</td>
                <td>
                  {data.StatusID ? "Active" : "Inactive"}
                </td>
                <td className="text-right">
                  <a
                    href="javascript:void(0);"
                    title="Edit"
                    className="btn btn-sm"
                    onClick={() =>
                      this.navigateRoleUpdate(data.roleID)
                    }
                  >
                    <i className="fa fa-edit action_btn_table" />
                  </a>
                  {data.StatusID==1?(
                    <a
                    title="Delete"
                    className="btn btn-sm delete_record"
                    onClick={() =>
                      this.handleDelete(data.roleID)
                    }
                    >
                    <i className="fa fa-trash action_btn_table" />
                  </a>
                  ):<></>}
                </td>
              </tr>
            ))
          : null}
      </tbody>
    </table>
    );
  }
  render() {
    const { isLoading, roleList,currentPage, isAccordionExpanded, Name, StatusID, roleID } =
      this.state;
      const recordsPerPage = 10;
      const indexOfLastRecord = currentPage * recordsPerPage;
      const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
      // Records to be displayed on the current page
      const currentRecords = roleList.slice(
        indexOfFirstRecord,
        indexOfLastRecord
      );
      const nPages = Math.ceil(roleList.length / recordsPerPage);
  
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[20]} />
            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">List of Role</h4>
                  <div>
                    <a
                      onClick={() => this.navigateRoleAdd()}
                      className="btn btn-primary btn-sm create_btn"
                    >
                      <i className="fa fa-plus" />{" "}
                      <span className="hidden-xs">Add Role</span>
                    </a>
                  </div>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search</h4>
                        <div className="searched_items">
                          <h5>
                            Role Name : <span>{Name}</span>
                          </h5>
                          <h5>
                            Status :{" "}
                            {StatusID ? (
                              <span>
                                {StatusID === "1" ? "Active" : "Inactive"}
                              </span>
                            ) : null}
                          </h5>
                          {/* <div class="chip">
              John Doe <span class="closebtn" onclick="this.parentElement.style.display='none'">&times;</span>
            </div> */}
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${
                          isAccordionExpanded ? "show" : ""
                        }`}
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Role Name</label>
                                <input
                                  type="text"
                                  className="form-control search_form_control"
                                  placeholder="Enter Role Name"
                                  value={Name}
                                  onChange={(e) =>
                                    this.setState({ Name: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Status</label>
                                <select
                                  className="form-control"
                                  value={StatusID} // Bind the selected value to the StatusID state.
                                  onChange={(e) =>
                                    this.setState({ StatusID: e.target.value })
                                  } // Update the StatusID state when the selection changes.
                                >
                                  <option value="">--select--</option>
                                  <option value="1">Active</option>
                                  <option value="0">Inactive</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button
                                onClick={this.handleSearch}
                                className="btn btn-primary search_btn"
                              >
                                Search
                              </button>
                              &nbsp;
                              <button
                                onClick={this.clearFilters}
                                className="btn btn-primary search_btn"
                              >
                                Clear Filters
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                    {this.roleRecords(currentRecords)}
                      {roleList.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <div id="createRole" className="modal fade" role="dialog">
            <div
              className="modal-dialog custom_modal_dialog modal-dialog-centered"
              role="document"
              style={{ minWidth: "55%" }}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="hearingModalLabel">
                    Add/Edit Role
                  </h5>
                  <button
                    type="button"
                    className="close modal_close_icon"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div
                  className="modal-body"
                  style={{ height: 600, overflow: "auto" }}
                >
                  <form>
                    <div className="row">
                      <div className="form-group col-md-4"></div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <button type="submit" className="btn save_btn mr-2">
                          Save
                        </button>
                        <a
                          className="btn back_btn"
                          id="cancel_co_applicant_pop"
                          data-dismiss="modal"
                        >
                          Cancel
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { role_list_action, fill_action, role_delete_action })(Role)
);
